import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "footer-right" }

import { content } from "@/content/data";


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "footer-divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, "© " + _toDisplayString(_unref(year)) + " " + _toDisplayString(_unref(content).name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Version " + _toDisplayString(_unref(content).appVersion), 1)
      ])
    ])
  ]))
}
}

})